var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgViewAsTraveler = function SvgViewAsTraveler(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.6,18.4H4.2c-0.9,0-1.6-0.7-1.6-1.6V3.1c0-0.9,0.7-1.6,1.6-1.6h9.6c0.9,0,1.6,0.7,1.6,1.6v7.5 c0,0.4,0.4,0.8,0.8,0.8s0.8-0.4,0.8-0.8V3.1c0-1.7-1.4-3.1-3.1-3.1H4.2C2.5,0,1.1,1.4,1.1,3.1v13.8c0,1.7,1.4,3.1,3.1,3.1h3.4 c0.4,0,0.8-0.4,0.8-0.8S8,18.4,7.6,18.4z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13,4.7H5C4.5,4.7,4.2,5,4.2,5.5S4.5,6.2,5,6.2h8c0.4,0,0.8-0.4,0.8-0.8S13.4,4.7,13,4.7z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.8,8.6c0-0.4-0.3-0.8-0.8-0.8H5c-0.4,0-0.8,0.4-0.8,0.8S4.5,9.4,5,9.4h8C13.4,9.4,13.8,9,13.8,8.6z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5,10.9c-0.4,0-0.8,0.4-0.8,0.8s0.4,0.8,0.8,0.8h4.1c0.4,0,0.8-0.4,0.8-0.8s-0.4-0.8-0.8-0.8H5z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 13.6,
    cy: 16.2,
    r: 1.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.9,15.5c-0.3-0.3-0.9-1.1-1.7-1.8c-2.2-1.7-4.5-1.7-6.7,0c-0.9,0.7-1.5,1.4-1.7,1.8 c-0.1,0.1-0.1,0.2-0.2,0.2l0,0c-0.1,0.1-0.1,0.3-0.1,0.5c0,0.2,0,0.3,0.1,0.5l0,0l0,0c0,0.1,0.1,0.2,0.2,0.2 c0.1,0.1,0.3,0.3,0.5,0.6l0.8,0.8c0.2,0.1,0.3,0.3,0.5,0.4c1.1,0.9,2.2,1.3,3.3,1.3s2.2-0.4,3.3-1.3c0.9-0.7,1.5-1.5,1.7-1.8 l0.2-0.8L18.9,15.5z M17.1,16.7c-1.1,1.2-2.2,1.8-3.2,1.8c-1.1,0-2.2-0.7-3.4-2c0,0-0.1-0.2-0.1-0.2l0,0l0,0c0,0,0.1-0.2,0.1-0.2 c1.2-1.3,2.3-2,3.4-2c1,0,2.1,0.6,3.2,1.8l0.3,0.5L17.1,16.7z",
    fill: "currentColor"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgViewAsTraveler, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/view-as-traveler.f46b78aa.svg";
export { ForwardRef as ReactComponent };